import { StringSchema } from 'yup';
import { PASSWORD_MIN_LENGTH, PASSWORD_MAX_LENGTH } from '../../../constants';

export class CredentialSchema extends StringSchema {
  password(
    messages: {
      min?: string;
      max?: string;
      alphanumeric?: string;
      whitespace?: string;
    } = {}
  ): this {
    // https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html
    return this.matches(
      // eslint-disable-next-line no-useless-escape
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-|~=`{}\[\]\/\\:";'<>?,.]).+$/,
      messages?.alphanumeric
    )
      .matches(/^\S*$/, messages?.whitespace)
      .min(PASSWORD_MIN_LENGTH, messages?.min)
      .max(PASSWORD_MAX_LENGTH, messages?.max);
  }

  passwordOld(): this {
    return this.trim();
  }
}

function create(): CredentialSchema {
  return new CredentialSchema();
}

create.prototype = CredentialSchema.prototype;

export default create;
